var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page-section', {
    staticClass: "page-section--xs"
  }, [_c('template', {
    slot: "containerImmersive"
  }, [_c('div', {
    staticClass: "pb-4 pb-md-5"
  }, [_c('list-head', _vm._g(_vm._b({}, 'list-head', {
    loading: _vm.loading
  }, false), {
    excel: _vm.excel
  }))], 1), _c('v-simple-table', _vm._b({
    staticClass: "v-data-table--default v-data-table--no-hover inventory-list-table",
    attrs: {
      "dense": ""
    }
  }, 'v-simple-table', {
    headers: _vm.headers
  }, false), [_c('thead', [_c('tr', [_vm._l(_vm.headers, function (header) {
    return _c('th', {
      key: header.value
    }, [_vm._v(" " + _vm._s(header.text) + " ")]);
  }), _c('th', [_vm._v("선택")])], 2)]), _c('tbody', [_vm._l(_vm.products, function (product, i) {
    return [_vm._l(product.purchases, function (purchase, j) {
      var _purchase$createdAt, _purchase$createdAt$t, _ref, _ref$format, _purchase$purchasePri, _purchase$purchasePri2, _ref2, _ref2$format;
      return [_c('tr', {
        key: `product-${i}-${purchase._id}`
      }, [j == 0 ? _c('td', {
        attrs: {
          "rowspan": product.purchases.length
        }
      }, [_vm._v(_vm._s(product === null || product === void 0 ? void 0 : product.fullName))]) : _vm._e(), j == 0 ? _c('td', {
        attrs: {
          "rowspan": product.purchases.length
        }
      }, [_vm._v(_vm._s((product === null || product === void 0 ? void 0 : product.code) || "-"))]) : _vm._e(), _c('td', [_vm._v(_vm._s((purchase === null || purchase === void 0 ? void 0 : (_purchase$createdAt = purchase.createdAt) === null || _purchase$createdAt === void 0 ? void 0 : (_purchase$createdAt$t = _purchase$createdAt.toDate) === null || _purchase$createdAt$t === void 0 ? void 0 : _purchase$createdAt$t.call(_purchase$createdAt)) || (purchase === null || purchase === void 0 ? void 0 : purchase.createdAt) || "-"))]), _c('td', [_vm._v(_vm._s(((_ref = (purchase === null || purchase === void 0 ? void 0 : purchase.amount) - (purchase === null || purchase === void 0 ? void 0 : purchase.amount_out)) === null || _ref === void 0 ? void 0 : (_ref$format = _ref.format) === null || _ref$format === void 0 ? void 0 : _ref$format.call(_ref)) || 0))]), _c('td', [_vm._v(_vm._s((purchase === null || purchase === void 0 ? void 0 : (_purchase$purchasePri = purchase.purchasePrice__unit) === null || _purchase$purchasePri === void 0 ? void 0 : (_purchase$purchasePri2 = _purchase$purchasePri.format) === null || _purchase$purchasePri2 === void 0 ? void 0 : _purchase$purchasePri2.call(_purchase$purchasePri)) || 0))]), _c('td', [_vm._v(_vm._s(((_ref2 = (purchase === null || purchase === void 0 ? void 0 : purchase.purchasePrice__unit) * ((purchase === null || purchase === void 0 ? void 0 : purchase.amount) - (purchase === null || purchase === void 0 ? void 0 : purchase.amount_out))) === null || _ref2 === void 0 ? void 0 : (_ref2$format = _ref2.format) === null || _ref2$format === void 0 ? void 0 : _ref2$format.call(_ref2)) || 0))]), _c('td', [_c('v-simple-checkbox', _vm._b({
        attrs: {
          "value": _vm.getIsSelected(purchase)
        },
        on: {
          "click": function ($event) {
            return _vm.toggleSelect(purchase);
          }
        }
      }, 'v-simple-checkbox', _vm.attrs_input, false))], 1)])];
    })];
  })], 2)]), _c('div', {
    staticClass: "pagination-wrap pagination-wrap--sm"
  }, [_c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }